import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-bigquery-checklist',
  templateUrl: './help-bigquery-checklist.component.html'
})
export class HelpBigqueryChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
